import { ActionIcon, Button, Flex, Menu, Table, Text } from '@mantine/core'
import classes from './AdminSettings.module.css'
import { useAppDispatch } from '@hooks/redux'
import { useEffect } from 'react'
import { setActiveSection } from '@redux/site/siteSlice'
import { IconDots } from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'

export const PermissionSetsList = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Permission Sets'))
  })

  const data = [
    {
      name: 'Administrator',
      staff: 2,
    },
    {
      name: 'Default',
      staff: 0,
    },
  ]

  const handleEditClick = () =>
    navigate(
      `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_PERMISSION_SETS}/${RoutePaths.ADMIN_SETTINGS_PERMISSION_SETS_DETAILS}`,
    )

  const rows = data.map((item) => (
    <Table.Tr key={item.name}>
      <Table.Td style={{ whiteSpace: 'pre' }}>{item.name}</Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>{item.staff}</Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>
        <Menu>
          <Menu.Target>
            <ActionIcon variant="default" radius="xl" aria-label="Options">
              <IconDots style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item color="dark" onClick={handleEditClick}>
              Edit
            </Menu.Item>
            <Menu.Item color="dark" onClick={() => {}}>
              Clone
            </Menu.Item>
            <Menu.Item color="red" onClick={() => {}}>
              Delete
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Table.Td>
    </Table.Tr>
  ))

  return (
    <>
      <Flex justify="flex-end" p="xs">
        <Button>Add Permission Set</Button>
      </Flex>
      <Table withRowBorders={false} verticalSpacing="xs">
        <Table.Thead>
          <Table.Tr className={classes.AdminSettings__thead}>
            <Table.Th key={`columns-1`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Name
              </Text>
            </Table.Th>

            <Table.Th key={`columns-2`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Staff
              </Text>
            </Table.Th>

            <Table.Th key={`columns-3`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                2 Results
              </Text>
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    </>
  )
}
